module.exports = "<div class=\"flash-message\" v-bind:class=\"[!isVisible ? 'flash-message--hidden' : '']\">\n  <span class=\"flash-message__close-btn icon-cross icon--action\" v-on:click=\"hide\"></span>\n  <div class=\"flash-message__content\">\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/flash-messages/partials/header.html
// module id = Ppz/
// module chunks = 1